export enum AuthProvider {
    Auth0 = 'auth0',
    Clerk = 'clerk',
}
